import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5587 2.54346C18.973 2.54346 19.3087 2.87924 19.3087 3.29346V6.92236C19.3087 7.31017 19.0131 7.63402 18.6269 7.66926L14.9126 8.00817C14.5001 8.04581 14.1352 7.74192 14.0976 7.32942C14.06 6.91692 14.3638 6.55201 14.7763 6.51437L16.9006 6.32054C13.9536 3.77198 9.4938 3.89701 6.69518 6.69563C3.76567 9.62514 3.76567 14.3748 6.69518 17.3043C9.62468 20.2338 14.3743 20.2338 17.3038 17.3043C18.7687 15.8394 19.501 13.9209 19.501 12C19.501 11.5858 19.8368 11.25 20.251 11.25C20.6652 11.25 21.001 11.5858 21.001 12C21.001 14.3025 20.122 16.6075 18.3645 18.365C14.8492 21.8803 9.14981 21.8803 5.63451 18.365C2.11922 14.8497 2.11922 9.15026 5.63451 5.63497C8.97007 2.29942 14.2721 2.12887 17.8087 5.12333V3.29346C17.8087 2.87924 18.1445 2.54346 18.5587 2.54346Z"
        fill={colorValue}
      />
    </svg>
  );
};
